import React from "react";
import "./destacado-planes.scss";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import { GatsbyImage } from "gatsby-plugin-image";
export interface PropsFeaturePlans {
  featureData: any;
}
const FeaturedPlans = (props: ReferenciaContenido) => {
  const data = props;
  return (
    <div className="m-featured-plans">
      <div className="m-featured-plans__container">
        <div className="m-featured-plans__container__img-desktop hide-on-mobile">
          <GatsbyImage
            className="m-featured-join__container__img-desktop"
            image={data?.imagenPrincipal?.gatsbyImageData}
            alt={
              data?.imagenPrincipal?.title
                ? data?.imagenPrincipal?.title
                : "Destacado principal"
            }
          />
        </div>
        <div className="m-featured-plans__container__img-mobile show-on-mobile">
          <GatsbyImage
            className="m-featured-plans__container__img-mobile"
            image={data?.imagenMobileMenteYCuerpo?.gatsbyImageData}
            alt={
              data?.imagenMobileMenteYCuerpo?.title
                ? data?.imagenMobileMenteYCuerpo?.title
                : "Destacado principal"
            }
          />
        </div>
        <div className="m-featured-plans__container__plans">
          <div className="m-featured-plans__container__plans__text">
            <h3>{data?.tituloGeneral}</h3>
          </div>
          <a
            className="m-featured-plans__container__plans__button  gtmRedDeAmorHabitosSaludMentalComienzaAhora"
            href={data?.redireccionBoton}
            target="__blank"
          >
            {data?.tituloBoton}
          </a>
          <p className="m-featured-plans__container__plans__tarifa show-on-mobile">
            {JSON.parse(data?.descripcion?.raw)?.content[0]?.content[0]?.value}
          </p>
        </div>
      </div>
    </div>
  );
};

export default FeaturedPlans;
